import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable } from 'rxjs';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { RealEstateAccountMovement } from '../core/models/RealEstateAccountMovement';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ContractBalanceAccountService {
  constructor(private apiService: ApiService) {}

  getAllPaginated(
    paginatedArguments: IPaginatedServiceParamters,
  ): Observable<PaginatedResult<RealEstateAccountMovement[]>> {
    return this.apiService.getPaginated(
      `/api/Contract/${paginatedArguments.id}/AccountMovements/`,
      paginatedArguments,
    );
  }

  downloadCSV(params: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Contract/AccountMovements/DownloadCSV', params);
  }

  downloadExcel(params: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Contract/AccountMovements/DownloadExcel', params);
  }
}
